import { Inject, Injectable, Injector }from '@angular/core';

import { Utilities_DatasourceService } from './Utilities.datasource.index';
import { PurchaseOrders_DatasourceService } from './PurchaseOrders.datasource.index';
import { Materials_DatasourceService } from './Materials.datasource.index';
import { SalesOrders_DatasourceService } from './SalesOrders.datasource.index';
import { Notifications_DatasourceService } from './Notifications.datasource.index';
import { Inventory_DatasourceService } from './Inventory.datasource.index';
import { FootprintApiManager_DatasourceService } from './FootprintApiManager.datasource.index';
import { Reports_DatasourceService } from './Reports.datasource.index';
import { FootprintEdi_DatasourceService } from './FootprintEdi.datasource.index';

import { app_custom_ds_get_child_orderlines_by_orderId_lineNumberService } from './app.datasource.index';
import { app_custom_ds_get_grouped_child_orderlines_by_orderId_lineNumberService } from './app.datasource.index';
import { app_custom_ds_get_material_soft_allocations_by_materialId_warehouseId_packagedIdService } from './app.datasource.index';
import { app_custom_ds_get_next_orderline_numberService } from './app.datasource.index';
import { app_custom_ds_get_not_eligible_inventory_by_material_packagedId_warehouseIdService } from './app.datasource.index';
import { app_custom_ds_get_order_by_orderIdService } from './app.datasource.index';
import { app_custom_ds_get_sales_order_lines_by_orderIdService } from './app.datasource.index';
import { app_custom_ds_get_zagg_ebp_ordersService } from './app.datasource.index';
import { app_custom_ds_inventory_availability_by_materialId_packagingId_warehouseIdService } from './app.datasource.index';
import { app_ds_get_inventory_by_project_lookupService } from './app.datasource.index';
import { app_ds_get_warehousesService } from './app.datasource.index';

@Injectable({ providedIn: 'root' })
export class app_DatasourceService {

  constructor(
    private injector: Injector
  ) {
    this.Utilities = this.injector.get(Utilities_DatasourceService);
    this.PurchaseOrders = this.injector.get(PurchaseOrders_DatasourceService);
    this.Materials = this.injector.get(Materials_DatasourceService);
    this.SalesOrders = this.injector.get(SalesOrders_DatasourceService);
    this.Notifications = this.injector.get(Notifications_DatasourceService);
    this.Inventory = this.injector.get(Inventory_DatasourceService);
    this.FootprintApiManager = this.injector.get(FootprintApiManager_DatasourceService);
    this.Reports = this.injector.get(Reports_DatasourceService);
    this.FootprintEdi = this.injector.get(FootprintEdi_DatasourceService);
  }

    public Utilities: Utilities_DatasourceService;
    public PurchaseOrders: PurchaseOrders_DatasourceService;
    public Materials: Materials_DatasourceService;
    public SalesOrders: SalesOrders_DatasourceService;
    public Notifications: Notifications_DatasourceService;
    public Inventory: Inventory_DatasourceService;
    public FootprintApiManager: FootprintApiManager_DatasourceService;
    public Reports: Reports_DatasourceService;
    public FootprintEdi: FootprintEdi_DatasourceService;
  public app: app_DatasourceService = this;

  // injecting lazily in order to avoid circular dependencies
  private _custom_ds_get_child_orderlines_by_orderId_lineNumber: app_custom_ds_get_child_orderlines_by_orderId_lineNumberService;
  public get custom_ds_get_child_orderlines_by_orderId_lineNumber(): app_custom_ds_get_child_orderlines_by_orderId_lineNumberService {
    if(!this._custom_ds_get_child_orderlines_by_orderId_lineNumber) {
      this._custom_ds_get_child_orderlines_by_orderId_lineNumber = this.injector.get(app_custom_ds_get_child_orderlines_by_orderId_lineNumberService);
    }
    return this._custom_ds_get_child_orderlines_by_orderId_lineNumber;
  }
  private _custom_ds_get_grouped_child_orderlines_by_orderId_lineNumber: app_custom_ds_get_grouped_child_orderlines_by_orderId_lineNumberService;
  public get custom_ds_get_grouped_child_orderlines_by_orderId_lineNumber(): app_custom_ds_get_grouped_child_orderlines_by_orderId_lineNumberService {
    if(!this._custom_ds_get_grouped_child_orderlines_by_orderId_lineNumber) {
      this._custom_ds_get_grouped_child_orderlines_by_orderId_lineNumber = this.injector.get(app_custom_ds_get_grouped_child_orderlines_by_orderId_lineNumberService);
    }
    return this._custom_ds_get_grouped_child_orderlines_by_orderId_lineNumber;
  }
  private _custom_ds_get_material_soft_allocations_by_materialId_warehouseId_packagedId: app_custom_ds_get_material_soft_allocations_by_materialId_warehouseId_packagedIdService;
  public get custom_ds_get_material_soft_allocations_by_materialId_warehouseId_packagedId(): app_custom_ds_get_material_soft_allocations_by_materialId_warehouseId_packagedIdService {
    if(!this._custom_ds_get_material_soft_allocations_by_materialId_warehouseId_packagedId) {
      this._custom_ds_get_material_soft_allocations_by_materialId_warehouseId_packagedId = this.injector.get(app_custom_ds_get_material_soft_allocations_by_materialId_warehouseId_packagedIdService);
    }
    return this._custom_ds_get_material_soft_allocations_by_materialId_warehouseId_packagedId;
  }
  private _custom_ds_get_next_orderline_number: app_custom_ds_get_next_orderline_numberService;
  public get custom_ds_get_next_orderline_number(): app_custom_ds_get_next_orderline_numberService {
    if(!this._custom_ds_get_next_orderline_number) {
      this._custom_ds_get_next_orderline_number = this.injector.get(app_custom_ds_get_next_orderline_numberService);
    }
    return this._custom_ds_get_next_orderline_number;
  }
  private _custom_ds_get_not_eligible_inventory_by_material_packagedId_warehouseId: app_custom_ds_get_not_eligible_inventory_by_material_packagedId_warehouseIdService;
  public get custom_ds_get_not_eligible_inventory_by_material_packagedId_warehouseId(): app_custom_ds_get_not_eligible_inventory_by_material_packagedId_warehouseIdService {
    if(!this._custom_ds_get_not_eligible_inventory_by_material_packagedId_warehouseId) {
      this._custom_ds_get_not_eligible_inventory_by_material_packagedId_warehouseId = this.injector.get(app_custom_ds_get_not_eligible_inventory_by_material_packagedId_warehouseIdService);
    }
    return this._custom_ds_get_not_eligible_inventory_by_material_packagedId_warehouseId;
  }
  private _custom_ds_get_order_by_orderId: app_custom_ds_get_order_by_orderIdService;
  public get custom_ds_get_order_by_orderId(): app_custom_ds_get_order_by_orderIdService {
    if(!this._custom_ds_get_order_by_orderId) {
      this._custom_ds_get_order_by_orderId = this.injector.get(app_custom_ds_get_order_by_orderIdService);
    }
    return this._custom_ds_get_order_by_orderId;
  }
  private _custom_ds_get_sales_order_lines_by_orderId: app_custom_ds_get_sales_order_lines_by_orderIdService;
  public get custom_ds_get_sales_order_lines_by_orderId(): app_custom_ds_get_sales_order_lines_by_orderIdService {
    if(!this._custom_ds_get_sales_order_lines_by_orderId) {
      this._custom_ds_get_sales_order_lines_by_orderId = this.injector.get(app_custom_ds_get_sales_order_lines_by_orderIdService);
    }
    return this._custom_ds_get_sales_order_lines_by_orderId;
  }
  private _custom_ds_get_zagg_ebp_orders: app_custom_ds_get_zagg_ebp_ordersService;
  public get custom_ds_get_zagg_ebp_orders(): app_custom_ds_get_zagg_ebp_ordersService {
    if(!this._custom_ds_get_zagg_ebp_orders) {
      this._custom_ds_get_zagg_ebp_orders = this.injector.get(app_custom_ds_get_zagg_ebp_ordersService);
    }
    return this._custom_ds_get_zagg_ebp_orders;
  }
  private _custom_ds_inventory_availability_by_materialId_packagingId_warehouseId: app_custom_ds_inventory_availability_by_materialId_packagingId_warehouseIdService;
  public get custom_ds_inventory_availability_by_materialId_packagingId_warehouseId(): app_custom_ds_inventory_availability_by_materialId_packagingId_warehouseIdService {
    if(!this._custom_ds_inventory_availability_by_materialId_packagingId_warehouseId) {
      this._custom_ds_inventory_availability_by_materialId_packagingId_warehouseId = this.injector.get(app_custom_ds_inventory_availability_by_materialId_packagingId_warehouseIdService);
    }
    return this._custom_ds_inventory_availability_by_materialId_packagingId_warehouseId;
  }
  private _ds_get_inventory_by_project_lookup: app_ds_get_inventory_by_project_lookupService;
  public get ds_get_inventory_by_project_lookup(): app_ds_get_inventory_by_project_lookupService {
    if(!this._ds_get_inventory_by_project_lookup) {
      this._ds_get_inventory_by_project_lookup = this.injector.get(app_ds_get_inventory_by_project_lookupService);
    }
    return this._ds_get_inventory_by_project_lookup;
  }
  private _ds_get_warehouses: app_ds_get_warehousesService;
  public get ds_get_warehouses(): app_ds_get_warehousesService {
    if(!this._ds_get_warehouses) {
      this._ds_get_warehouses = this.injector.get(app_ds_get_warehousesService);
    }
    return this._ds_get_warehouses;
  }
}

